import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/PatientProfileSection.css';

const PatientProfileSection = () => {
  const { currentUser, logout } = useAuth();
  
  // Function to get user initials
  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase();
  };

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-avatar">
          {getInitials(currentUser?.name || '')}
        </div>
        <h2>My Profile</h2>
        <p className="profile-email">{currentUser?.email}</p>
      </div>

      <div className="profile-details">
        <div className="detail-item">
          <label>Full Name</label>
          <div className="detail-value">{currentUser?.name || 'Not provided'}</div>
        </div>
        
        {currentUser?.phone && (
          <div className="detail-item">
            <label>Phone</label>
            <div className="detail-value">{currentUser.phone}</div>
          </div>
        )}
        
        {currentUser?.dateOfBirth && (
          <div className="detail-item">
            <label>Date of Birth</label>
            <div className="detail-value">
              {new Date(currentUser.dateOfBirth).toLocaleDateString()}
            </div>
          </div>
        )}
        
        {currentUser?.address && (
          <div className="detail-item">
            <label>Address</label>
            <div className="detail-value">{currentUser.address}</div>
          </div>
        )}
      </div>

      <div className="profile-actions">
        <button 
          className="logout-button"
          onClick={logout}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default PatientProfileSection;
